module.exports = __webpack_public_path__ + "static/img/sustainable-introduction_2025.74388f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-introduction_2025.jpg
// module id = rrG3
// module chunks = 99